import { Injectable } from '@angular/core';
import { DropDownRange } from 'app/modules/organization/modules/dashboard/components/drop-down-range/drop-down-range.component';
import { DateTime } from 'luxon';
import { map, ReplaySubject, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardRangeService {
  readonly range$ = new ReplaySubject<{ name: DropDownRange, start?: string, end?: string }>(1);
  readonly rangeName$ = this.range$.asObservable().pipe(
    map(range => range.name),
    shareReplay({bufferSize: 1, refCount: true})
  );
  constructor() {
    const currentDate = DateTime.now().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const range = {
      name: DropDownRange.Last7days,
      start: currentDate.minus({ days: 6 }).toISO()
    }
    this.range$.next(range);
  }
}